export default {
  namespaced: true,
  state: () => ({
    showSuccessPopup: false,
    showCountriesPopup: false,
    selectedCountryIds: [] as number[],
    examId: null as number | null
  }),
  mutations: {
    SET_POPUP(state: any, payload: boolean) {
      state.showSuccessPopup = payload;
    },
    SET_POPUP_LOCAL(state: any, payload: { visible: boolean; countryIds?: number[]; examId?: number }) {
      state.showCountriesPopup = payload.visible;
      state.selectedCountryIds = payload.countryIds || [];
      state.examId = payload.examId || null;
    },
  },
  actions: {
    openPopup({ commit }: any) {
      commit("SET_POPUP", true);
    },
    closePopup({ commit }: any) {
      commit("SET_POPUP", false);
    },
    openPopupLocal({ commit }: any, payload: { countryIds?: number[], examId?: number }) {
      commit("SET_POPUP_LOCAL", { visible: true, ...payload });
    },
    closePopupLocal({ commit }: any) {
      commit("SET_POPUP_LOCAL", { visible: false });
    },
  },
};
